import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage"
import axios from "axios"
import DiagnosisInformation from "./diagnosis"

const DiagnosisPatientContainer = () => {
  const submitDiagnosisInfo = (event, diagnosisInfo) => {
    event.preventDefault();
    axios.post("https://arogyanxtdevapi.fundaclear.in/api/Diagnosis", diagnosisInfo).then((res) =>{
      if(res?.status === 200){
        // navigate("/opd", { state: { addPatient: false } })
        successToast(res?.data?.message);
      }
    }).catch((err) =>{
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    })
  }

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DiagnosisInformation submitDiagnosisInfo={submitDiagnosisInfo} />
        </>
      </div>
    </div>
  )
}

export default DiagnosisPatientContainer